import { Link, useMatches } from 'react-router';
import { ChevronRight } from 'lucide-react';

interface RouteHandle {
  breadcrumb?: string;
}

export function Breadcrumbs() {
  const matches = useMatches();

  const crumbs = matches
    .filter((match) => (match.handle as RouteHandle)?.breadcrumb)
    .map((match) => ({
      label: (match.handle as RouteHandle).breadcrumb!,
      path: match.pathname,
    }));

  if (crumbs.length <= 1) return null;

  return (
    <nav className="flex items-center gap-1 text-sm text-ink-tertiary mb-4">
      {crumbs.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1;
        return (
          <span key={crumb.path} className="flex items-center gap-1">
            {idx > 0 && <ChevronRight className="h-3.5 w-3.5" />}
            {isLast ? (
              <span className="text-ink font-medium">{crumb.label}</span>
            ) : (
              <Link to={crumb.path} className="hover:text-ink transition-colors">
                {crumb.label}
              </Link>
            )}
          </span>
        );
      })}
    </nav>
  );
}
